/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DigitaloceanDomainsListRsp } from '../models/digitalocean-domains-list-rsp';
import { DigitaloceanDomainsCreateRsp } from '../models/digitalocean-domains-create-rsp';
import { DigitaloceanDomainsCreateReq } from '../models/digitalocean-domains-create-req';
import { DigitaloceanDomainsLookupRsp } from '../models/digitalocean-domains-lookup-rsp';
import { DigitaloceanDomainsDeleteRsp } from '../models/digitalocean-domains-delete-rsp';
import { DigitaloceanDomainRecordsListRsp } from '../models/digitalocean-domain-records-list-rsp';
import { DigitaloceanDomainRecordsRsp } from '../models/digitalocean-domain-records-rsp';
import { DigitaloceanDomainRecordsCreateReq } from '../models/digitalocean-domain-records-create-req';
import { DigitaloceanDomainRecordsUpdateReq } from '../models/digitalocean-domain-records-update-req';
import { DigitaloceanDomainRecordsDeleteRsp } from '../models/digitalocean-domain-records-delete-rsp';
@Injectable({
  providedIn: 'root',
})
class NameserverServiceService extends __BaseService {
  static readonly DomainsListPath = '/api/digitalocean/v2/domains';
  static readonly DomainsCreatePath = '/api/digitalocean/v2/domains';
  static readonly DomainsLookupPath = '/api/digitalocean/v2/domains/{domain}';
  static readonly DomainsDeletePath = '/api/digitalocean/v2/domains/{domain}';
  static readonly DomainRecordsListPath = '/api/digitalocean/v2/domains/{domain}/records';
  static readonly DomainRecordsCreatePath = '/api/digitalocean/v2/domains/{domain}/records';
  static readonly DomainRecordsLookupPath = '/api/digitalocean/v2/domains/{domain}/records/{id}';
  static readonly DomainRecordsUpdatePath = '/api/digitalocean/v2/domains/{domain}/records/{id}';
  static readonly DomainRecordsDeletePath = '/api/digitalocean/v2/domains/{domain}/records/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `NameserverServiceService.DomainsListParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainsListResponse(params: NameserverServiceService.DomainsListParams): __Observable<__StrictHttpResponse<DigitaloceanDomainsListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.perPage != null) __params = __params.set('per_page', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/domains`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainsListRsp>;
      })
    );
  }
  /**
   * @param params The `NameserverServiceService.DomainsListParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainsList(params: NameserverServiceService.DomainsListParams): __Observable<DigitaloceanDomainsListRsp> {
    return this.DomainsListResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDomainsListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  DomainsCreateResponse(body: DigitaloceanDomainsCreateReq): __Observable<__StrictHttpResponse<DigitaloceanDomainsCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/digitalocean/v2/domains`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainsCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  DomainsCreate(body: DigitaloceanDomainsCreateReq): __Observable<DigitaloceanDomainsCreateRsp> {
    return this.DomainsCreateResponse(body).pipe(
      __map(_r => _r.body as DigitaloceanDomainsCreateRsp)
    );
  }

  /**
   * @param params The `NameserverServiceService.DomainsLookupParams` containing the following parameters:
   *
   * - `domain`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainsLookupResponse(params: NameserverServiceService.DomainsLookupParams): __Observable<__StrictHttpResponse<DigitaloceanDomainsLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/domains/${params.domain}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainsLookupRsp>;
      })
    );
  }
  /**
   * @param params The `NameserverServiceService.DomainsLookupParams` containing the following parameters:
   *
   * - `domain`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainsLookup(params: NameserverServiceService.DomainsLookupParams): __Observable<DigitaloceanDomainsLookupRsp> {
    return this.DomainsLookupResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDomainsLookupRsp)
    );
  }

  /**
   * @param domain undefined
   * @return A successful response.
   */
  DomainsDeleteResponse(domain: string): __Observable<__StrictHttpResponse<DigitaloceanDomainsDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/digitalocean/v2/domains/${domain}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainsDeleteRsp>;
      })
    );
  }
  /**
   * @param domain undefined
   * @return A successful response.
   */
  DomainsDelete(domain: string): __Observable<DigitaloceanDomainsDeleteRsp> {
    return this.DomainsDeleteResponse(domain).pipe(
      __map(_r => _r.body as DigitaloceanDomainsDeleteRsp)
    );
  }

  /**
   * @param params The `NameserverServiceService.DomainRecordsListParams` containing the following parameters:
   *
   * - `domain`: not required, autofill from uri
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainRecordsListResponse(params: NameserverServiceService.DomainRecordsListParams): __Observable<__StrictHttpResponse<DigitaloceanDomainRecordsListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.perPage != null) __params = __params.set('per_page', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/domains/${params.domain}/records`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainRecordsListRsp>;
      })
    );
  }
  /**
   * @param params The `NameserverServiceService.DomainRecordsListParams` containing the following parameters:
   *
   * - `domain`: not required, autofill from uri
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainRecordsList(params: NameserverServiceService.DomainRecordsListParams): __Observable<DigitaloceanDomainRecordsListRsp> {
    return this.DomainRecordsListResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDomainRecordsListRsp)
    );
  }

  /**
   * @param params The `NameserverServiceService.DomainRecordsCreateParams` containing the following parameters:
   *
   * - `domain`: not required, autofill from uri
   *
   * - `body`:
   *
   * @return A successful response.
   */
  DomainRecordsCreateResponse(params: NameserverServiceService.DomainRecordsCreateParams): __Observable<__StrictHttpResponse<DigitaloceanDomainRecordsRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/digitalocean/v2/domains/${params.domain}/records`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainRecordsRsp>;
      })
    );
  }
  /**
   * @param params The `NameserverServiceService.DomainRecordsCreateParams` containing the following parameters:
   *
   * - `domain`: not required, autofill from uri
   *
   * - `body`:
   *
   * @return A successful response.
   */
  DomainRecordsCreate(params: NameserverServiceService.DomainRecordsCreateParams): __Observable<DigitaloceanDomainRecordsRsp> {
    return this.DomainRecordsCreateResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDomainRecordsRsp)
    );
  }

  /**
   * @param params The `NameserverServiceService.DomainRecordsLookupParams` containing the following parameters:
   *
   * - `id`: not required, autofill from uri
   *
   * - `domain`: not required, autofill from uri
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainRecordsLookupResponse(params: NameserverServiceService.DomainRecordsLookupParams): __Observable<__StrictHttpResponse<DigitaloceanDomainRecordsRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/domains/${params.domain}/records/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainRecordsRsp>;
      })
    );
  }
  /**
   * @param params The `NameserverServiceService.DomainRecordsLookupParams` containing the following parameters:
   *
   * - `id`: not required, autofill from uri
   *
   * - `domain`: not required, autofill from uri
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DomainRecordsLookup(params: NameserverServiceService.DomainRecordsLookupParams): __Observable<DigitaloceanDomainRecordsRsp> {
    return this.DomainRecordsLookupResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDomainRecordsRsp)
    );
  }

  /**
   * @param params The `NameserverServiceService.DomainRecordsUpdateParams` containing the following parameters:
   *
   * - `id`: not required, autofill from uri
   *
   * - `domain`: not required, autofill from uri
   *
   * - `body`:
   *
   * @return A successful response.
   */
  DomainRecordsUpdateResponse(params: NameserverServiceService.DomainRecordsUpdateParams): __Observable<__StrictHttpResponse<DigitaloceanDomainRecordsRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    __body = params.body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/digitalocean/v2/domains/${params.domain}/records/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainRecordsRsp>;
      })
    );
  }
  /**
   * @param params The `NameserverServiceService.DomainRecordsUpdateParams` containing the following parameters:
   *
   * - `id`: not required, autofill from uri
   *
   * - `domain`: not required, autofill from uri
   *
   * - `body`:
   *
   * @return A successful response.
   */
  DomainRecordsUpdate(params: NameserverServiceService.DomainRecordsUpdateParams): __Observable<DigitaloceanDomainRecordsRsp> {
    return this.DomainRecordsUpdateResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDomainRecordsRsp)
    );
  }

  /**
   * @param params The `NameserverServiceService.DomainRecordsDeleteParams` containing the following parameters:
   *
   * - `id`: not required, autofill from uri
   *
   * - `domain`: not required, autofill from uri
   *
   * @return A successful response.
   */
  DomainRecordsDeleteResponse(params: NameserverServiceService.DomainRecordsDeleteParams): __Observable<__StrictHttpResponse<DigitaloceanDomainRecordsDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/digitalocean/v2/domains/${params.domain}/records/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDomainRecordsDeleteRsp>;
      })
    );
  }
  /**
   * @param params The `NameserverServiceService.DomainRecordsDeleteParams` containing the following parameters:
   *
   * - `id`: not required, autofill from uri
   *
   * - `domain`: not required, autofill from uri
   *
   * @return A successful response.
   */
  DomainRecordsDelete(params: NameserverServiceService.DomainRecordsDeleteParams): __Observable<DigitaloceanDomainRecordsDeleteRsp> {
    return this.DomainRecordsDeleteResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDomainRecordsDeleteRsp)
    );
  }
}

module NameserverServiceService {

  /**
   * Parameters for DomainsList
   */
  export interface DomainsListParams {
    perPage?: string;
    page?: string;
    fields?: Array<'field_all' | 'field_name' | 'field_ttl' | 'field_zone_file'>;
  }

  /**
   * Parameters for DomainsLookup
   */
  export interface DomainsLookupParams {
    domain: string;
    fields?: Array<'field_all' | 'field_name' | 'field_ttl' | 'field_zone_file'>;
  }

  /**
   * Parameters for DomainRecordsList
   */
  export interface DomainRecordsListParams {

    /**
     * not required, autofill from uri
     */
    domain: string;
    perPage?: string;
    page?: string;
    fields?: Array<'field_all' | 'field_id' | 'field_type' | 'field_name' | 'field_data' | 'field_priority' | 'field_port' | 'field_ttl' | 'field_weight' | 'field_flags' | 'field_tag'>;
  }

  /**
   * Parameters for DomainRecordsCreate
   */
  export interface DomainRecordsCreateParams {

    /**
     * not required, autofill from uri
     */
    domain: string;
    body: DigitaloceanDomainRecordsCreateReq;
  }

  /**
   * Parameters for DomainRecordsLookup
   */
  export interface DomainRecordsLookupParams {

    /**
     * not required, autofill from uri
     */
    id: string;

    /**
     * not required, autofill from uri
     */
    domain: string;
    fields?: Array<'field_all' | 'field_id' | 'field_type' | 'field_name' | 'field_data' | 'field_priority' | 'field_port' | 'field_ttl' | 'field_weight' | 'field_flags' | 'field_tag'>;
  }

  /**
   * Parameters for DomainRecordsUpdate
   */
  export interface DomainRecordsUpdateParams {

    /**
     * not required, autofill from uri
     */
    id: string;

    /**
     * not required, autofill from uri
     */
    domain: string;
    body: DigitaloceanDomainRecordsUpdateReq;
  }

  /**
   * Parameters for DomainRecordsDelete
   */
  export interface DomainRecordsDeleteParams {

    /**
     * not required, autofill from uri
     */
    id: string;

    /**
     * not required, autofill from uri
     */
    domain: string;
  }
}

export { NameserverServiceService }
